import { LayoutFieldsSetupNamesType } from "@whatslly/types/LayoutFieldsSetupType";
import { RecordTypeInfo } from "@whatslly/types/SfGetDescribeResponse";
export type FormattedLayoutKeyType = { entity: LayoutFieldsSetupNamesType; recordTypeSelector?: string; isDefault?: boolean };

export class FormattedRecordType {
  active: boolean;
  available: boolean;
  name: string;
  recordTypeSelector: string;
  isDefault: boolean;
  entity: LayoutFieldsSetupNamesType;
  recordTypeId: string;
  constructor(recordType: RecordTypeInfo | FormattedRecordType, entity: LayoutFieldsSetupNamesType, layoutKeys: string[]) {
    this.active = recordType.active;
    const recordTypeIdToUse = getRecordTypeSelector(recordType, layoutKeys);
    this.available = recordType.available;
    this.name = recordType.name;
    this.recordTypeId = recordType.recordTypeId;
    this.recordTypeSelector = recordTypeIdToUse.replace(":default", "").replace(`${entity}:`, "");
    this.isDefault = recordTypeIdToUse.endsWith(":default");
    this.entity = entity;
  }

  static formatLeyoutKey(layoutKey: string): FormattedLayoutKeyType {
    const splitedLayoutKey = layoutKey.split(":");
    const baseTypeLayoutKey = splitedLayoutKey[0];
    const recordTypeSelector = splitedLayoutKey[1];
    const isDefault = Boolean(splitedLayoutKey[2]);
    return { entity: baseTypeLayoutKey as LayoutFieldsSetupNamesType, recordTypeSelector: recordTypeSelector, isDefault };
  }

  static formattedLayoutKeyToString(formattedLayoutKey: FormattedLayoutKeyType) {
    let layoutKey = formattedLayoutKey.entity;
    if (formattedLayoutKey.recordTypeSelector) {
      layoutKey += `:${formattedLayoutKey.recordTypeSelector}`;
      if (formattedLayoutKey.isDefault) layoutKey += ":default";
    }
    return layoutKey;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isRecordTypeInfo(obj: any): obj is RecordTypeInfo {
  return (
    obj &&
    typeof obj.active === "boolean" &&
    typeof obj.available === "boolean" &&
    typeof obj.name === "string" &&
    typeof obj.recordTypeId === "string" &&
    typeof obj.defaultRecordTypeMapping === "boolean"
  );
}

function getRecordTypeSelector(recordType: RecordTypeInfo | FormattedRecordType, layoutKeys: string[]) {
  if (isRecordTypeInfo(recordType)) {
    return layoutKeys.some((fieldKey) => fieldKey.includes(`${recordType.recordTypeId}`))
      ? recordType.recordTypeId
      : recordType.developerName || recordType.recordTypeId;
  }

  return recordType.recordTypeSelector;
}
